<template>
  <div id="app" :class="{ 'global-hide-footer': !ui.showFooter }" class="app-container">
    <Header v-if="ui.showFooter" />
    <!-- <BannerSwiper /> -->
    <main>
      <router-view v-slot="{ Component }">
        <transition name="fade" mode="out-in">
          <component :is="Component" />
        </transition>
      </router-view>
    </main>
    <CustomFooter v-if="ui.showFooter" />
    <div class="to-top" @click="scrollToTop" v-show="showScrollTop">
      <i class="pi pi-arrow-up"></i>
    </div>
  </div>
    <StagewiseToolbar v-if="isDev" :config="stagewiseConfig" />
</template>

<script setup>
import { useUiStore } from '@/store/ui'
import { useRoute } from 'vue-router'
import { watch, ref, onMounted, onUnmounted } from 'vue'
const ui = useUiStore()
const route = useRoute()

// 监听路由变化，非首页自动显示Footer
watch(
  () => route.path,
  (newPath) => {
    if (newPath === '/' || newPath === '/home') {
      // 首页动画控制Footer显示，Home.vue会自己设置
    } else {
      ui.showFooter = true
    }
  },
  { immediate: true }
)

// 回到顶部按钮相关逻辑
const showScrollTop = ref(false)
const handleScroll = () => {
  showScrollTop.value = window.scrollY > 300
}
const scrollToTop = () => {
  window.scrollTo({
    top: 0,
    behavior: "smooth",
  })
}
onMounted(() => {
  window.addEventListener("scroll", handleScroll)
})
onUnmounted(() => {
  window.removeEventListener("scroll", handleScroll)
})
</script>

<script>
import { ref, onMounted, onUnmounted, computed } from "vue";
import { StagewiseToolbar } from '@stagewise/toolbar-vue';

const stagewiseConfig = {
  plugins: []
};

const isDev = process.env.NODE_ENV === 'development';
import Header from "./components/Header.vue";
import BannerSwiper from "./components/Banner.vue";
import CustomFooter from "./components/CustomFooter.vue";

export default {
  name: "App",
  components: {
    Header,
    BannerSwiper,
    CustomFooter,
  },
  setup() {
    const showScrollTop = ref(false);

    const handleScroll = () => {
      showScrollTop.value = window.scrollY > 300;
    };

    const scrollToTop = () => {
      window.scrollTo({
        top: 0,
        behavior: "smooth",
      });
    };

    onMounted(() => {
      window.addEventListener("scroll", handleScroll);
    });

    onUnmounted(() => {
      window.removeEventListener("scroll", handleScroll);
    });

    return {
      showScrollTop,
      scrollToTop,
    };
  },
};
</script>

<style>
.fade-enter-active,
.fade-leave-active {
  transition: opacity 0.3s ease;
}

.fade-enter-from,
.fade-leave-to {
  opacity: 0;
}

.to-top {
  position: fixed;
  bottom: 20px;
  right: 20px;
  width: 50px;
  height: 50px;
  background-color: var(--primary-color);
  color: white;
  border-radius: 50%;
  display: flex;
  justify-content: center;
  align-items: center;
  cursor: pointer;
  z-index: 99;
  box-shadow: 0 2px 10px rgba(0, 0, 0, 0.2);
  transition: all 0.3s ease;
}

.to-top:hover {
  background-color: #0b5ed7;
  transform: translateY(-3px);
}

.global-hide-footer .custom-footer {
  display: none !important;
}
</style>
